var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2439"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2439"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.39570",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};